// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TDmFY","col":"styles_col__3EPEI"};